<template>
  <div class="normalNumberInputStyle">
    <v-text-field
      v-model="inputedValue"
      type="number"
      dense
      :height="height"
      outlined
      hide-details
      :min="min"
    ></v-text-field>
  </div>
</template>

<script>
export default {
  components: {
    //
  },
  props: {
    value: {
      type: Number,
      require: true,
      default: () => 0
    },
    height: { default: '32px' },
    min: {
      type: Number,
      require: false,
      default: () => 0
    }
  },
  data: () => ({
    items: []
  }),
  created() {
    //
  },
  methods: {
    //
  },
  computed: {
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', Number(newValue))
      }
    }
  }
}
</script>
<style scoped lang="scss">
.normalNumberInputStyle {
  width: 100%;
}
</style>
